import * as ajax from "../../../../actions/ajaxCounterActions";
import * as exception from "../../../../actions/exceptionActions";

import financieelApi from "../../../../api/financieelApi";

import { getStore } from "../../../../store/configureStore";
import * as constants from "../../../../constants/DomainConstants";
import showToastr, { showToastrInfo, showToastrError, showToastrSuccess } from "../../../../util/toastr.js";
import redirector from '../../../../util/redirector';
import emptyGuid from "../../../../util/emptyGuid.js";

export default class FinancierEditPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const dossierId = this.context.props.params.dossierId;
		const financierId = this.context.props.params.financierId;

		if (financierId) {
			this.getFinancier(financierId);
			this.context.setState({ dossierId: dossierId, financierId: financierId, dossierRedenVanStatus: null });
		}
		else {
			this.getEmptyFinancier(dossierId);
			this.context.setState({ dossierId: dossierId, dossierRedenVanStatus: null });
		}

		if (dossierId) {
			this.context.props.getContent(dossierId, constants.DocumentTab.FinancieelSubtabFinanciering)
				.then(result => {
					if (result.success) {
						this.context.setState(
							{
								documenten: result.data
							});
					} else {
						showToastrError("Laden van het dossier is mislukt");
						throw new Error("getContent load failed"); //Stops promise
					}
				});
		}
		this.context.props.getSjablonen(constants.DocumentTab.FinancieelSubtabFinanciering)
			.then(result => {
				if (result.success) {
					this.context.setState(
						{
							sjablonen: result.data
						});
				} else {
					showToastrError("Laden van de sjablonen is mislukt");
					throw new Error("getSjablonen load failed"); //Stops promise
				}
			});
	}

	loadLayout(financieel) {
		this.context.props.loadLayout(financieel.naam, financieel.tabTitel, financieel.typeDossier);
	}

	loadBeads(beadModels) {
		this.context.props.beadsLoaded(beadModels);
	}

	change(event) {
		const fieldName = event.target.name;
		const value = event.target.value;
		let model = this.context.state.model;

		if (fieldName === "financierId")
			if (value != emptyGuid())
				model["naam"] = null;

		model[fieldName] = value;

		this.context.setState({ model: model, hasUnsavedChanges: true });
	}

	getFinancier(financierId) {
		this.dispatch(ajax.started());
		financieelApi.getFinancier(financierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterGet(response.data);
				this.loadLayout(response.data);
				this.loadBeads(response.data.beadModels);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	getEmptyFinancier(dossierId) {
		this.dispatch(ajax.started());
		financieelApi.getEmptyFinancier(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.setStateAfterGet(response.data);
				this.loadLayout(response.data);
				this.loadBeads(response.data.beadModels);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	save() {
		//event.preventDefault();

		if (this.context.state.fileSessionStarted) {
			showToastrInfo("Verwerken van bestanden. Even geduld");

			this.context.props.endFileSession(this.context.props.dossierId, constants.DocumentTab.FinancieelSubtabFinanciering)
				.then(result => {
					if (!result.success) {
						showToastrError(constants.HAS_FILE_EXCEPTION);
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: false });
						showToastrSuccess("Verwerken van bestanden gelukt");
					}

				});
		}

		this.dispatch(ajax.started());
		financieelApi.saveFinancier(this.context.state.model, this.context.state.documenten)
			.then((response) => {
				this.dispatch(ajax.ended());
				let result = null;
				if (response.data.concurrencyException) {
					this.setStateAfterUpdate(response.data.item, response.data.validationResults);
					result = constants.HAS_CONCURRENCY_EXCEPTION;
				} else if (response.data.hasValidationErrors) {
					this.setStateAfterUpdate(response.data.item, response.data.validationResults);
					result = constants.HAS_VALIDATION_ERRORS;
				} else if (Object.keys(response.data.validationResults).length !== 0) {
					this.setStateAfterUpdate(response.data.item, response.data.validationResults);
					result = constants.HAS_VALIDATION_ERRORS_SAVED;
				} else {
					this.setStateAfterUpdate(response.data.item, {}, false);
					result = constants.SUCCESS;
				}
				let isSaved = showToastr(result);
				if (isSaved) {
					this.context.setState({ hasUnsavedChanges: false });
					if (result === constants.SUCCESS)
						this.goToOverview();
				}
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	goToOverview() {
		redirector.goTo(`/financieel/${this.context.state.dossierId}/financiering`);
	}

	setStateAfterUpdate(model, validationMessages) {
		this.context.setState({
			model: model,
			validationMessages: validationMessages
		});
	}

	setStateAfterGet(model, validationMessages, hasUnsavedChanges) {
		this.context.setState({
			model: model.financier,
			aanvragers: model.aanvragers,
			dossierRedenVanStatus: model.redenVanStatus,
			totaleInvestering: model.totaleInvestering,

			validationMessages: validationMessages,
			hasUnsavedChanges: hasUnsavedChanges == undefined ? this.context.state.hasUnsavedChanges : hasUnsavedChanges
		});
	}

	handleFileRequest(component, actionParam, fileProcess) {
		if (!this.context.state.fileSessionStarted) {
			this.context.props.startFileSession(this.context.props.dossierId, constants.DocumentTab.FinancieelSubtabFinanciering)
				.then(result => {
					if (!result.success) {
						showToastrError("Verwerken van bestand is mislukt");
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({
							fileSessionStarted: true,
							hasUnsavedChanges: true
						});
					}
				}).then(() => fileProcess(component, actionParam));
		}
		else
			fileProcess(component, actionParam);
	}
}